import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPhonecentersMaintenance = (phonecentersMaintenanceId: number | undefined): Promise<IGetPhonecentersMaintenance> => {
  return axiosDefaultApi.get(`/api/PhonecentersMaintenance/GetPhonecentersMaintenanceViaID/${phonecentersMaintenanceId}`);
};

type QueryFnType = typeof getPhonecentersMaintenance;

type UseGetPhonecentersMaintenanceOptions = {
  phonecentersMaintenanceId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPhonecentersMaintenance = ({ phonecentersMaintenanceId , config }: UseGetPhonecentersMaintenanceOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPhonecentersMaintenance_${phonecentersMaintenanceId}`],
    queryFn: () => getPhonecentersMaintenance(phonecentersMaintenanceId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Συντηρητή.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};